import {useTranslation} from 'react-i18next';
import * as css from './ImageHeader.css';

function ImageHeader({text='imageText', height=160, width=630}) {
    const {t}=useTranslation('branding');
    return (
        <css.recommendedSize>
            <span>{t(`${text}`)}</span>
            <span>{t('recommendedSize', {size: `${width}x${height}`})}</span>
        </css.recommendedSize>
    );
}

export default ImageHeader;